import React from "react";
import { Modal, Button, Row, Col } from "react-bootstrap";
import { func, bool, object, string, number, oneOfType } from "prop-types";
import { trackTalentMobilityCandidateCopied } from "utils/trackingFunctions";

const CopyCandidateConfirmationModal = ({
  showModal,
  hideModal,
  onCopyCandidateToJob,
  candidateInfo,
  selectedJobToCopyCandidate,
  pipelineStageName,
  companyAccountId,
}) => {
  const candidateFirstName = candidateInfo.get("testTakerFirstName");
  const testTakerId = candidateInfo.get("testTakerId");
  const currentJobDetailId = candidateInfo.get("jobDetailId");

  const jobToCopyCandidateTitle =
    selectedJobToCopyCandidate && selectedJobToCopyCandidate.get("jobTitle");

  const handleCopyCandidateToJob = () => {
    trackTalentMobilityCandidateCopied(
      currentJobDetailId,
      selectedJobToCopyCandidate.get("jobDetailId"),
      pipelineStageName,
      companyAccountId
    );

    onCopyCandidateToJob(
      [testTakerId],
      selectedJobToCopyCandidate.get("jobDetailId"),
      currentJobDetailId
    );
    hideModal();
  };

  return (
    <Modal
      show={showModal}
      onHide={hideModal}
      className="copyCandidateConfirmationModal"
    >
      <Modal.Header closeButton>
        <h4>
          Copy {candidateFirstName} to {jobToCopyCandidateTitle}
        </h4>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <p>
              {candidateFirstName} will be visible in the{" "}
              <strong>{pipelineStageName}</strong> stage of the{" "}
              {jobToCopyCandidateTitle} job. If you copy {candidateFirstName} to
              a different pipeline stage, any automated actions associated with
              the {jobToCopyCandidateTitle} job will apply.
            </p>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="text-right">
        <Button
          variant="outline-primary"
          className="btn-cancel"
          onClick={hideModal}
        >
          Cancel
        </Button>
        <Button
          onClick={handleCopyCandidateToJob}
          variant="primary"
          className="btn-criteria-primary"
          id="copyCandidateToJob"
        >
          Copy
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CopyCandidateConfirmationModal.propTypes = {
  showModal: bool,
  hideModal: func,
  onCopyCandidateToJob: func,
  candidateInfo: object,
  selectedJobToCopyCandidate: object,
  pipelineStageName: oneOfType([string, bool]),
  companyAccountId: number,
};

export default CopyCandidateConfirmationModal;
